const leadForensicsConfig = window?.propel?.leadForensics ?? {};

const escapeValue = (value, maxLength) =>
	escape(value ?? '')
		.substring(0, maxLength)
		.replace(/\%u00a0/g, '')
		.replace(/\%u2122/g, '')
		.replace(/\%u[0-9][0-9][0-9][0-9]/g, '');

const generateGuid = () =>
	'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
		const randomValue = Math.floor(Math.random() * 16);
		const value = 'x' === character ? randomValue : (randomValue % 4) + 8;

		return value.toString(16);
	});

export const trackLoad = (docloc, doctit) => {
	if (
		!leadForensicsConfig.enabled ||
		!leadForensicsConfig.accountId ||
		!leadForensicsConfig.captureUrl
	) {
		return;
	}

	const params = [
		`trk_user=${leadForensicsConfig.accountId}`,
		`trk_sw=${escape(screen.width).substring(0, 6)}`,
		`trk_sh=${escape(screen.height).substring(0, 6)}`,
		`trk_ref=${escape(document.referrer).substring(0, 1100)}`,
		`trk_tit=${escapeValue(doctit, 200)}`,
		`trk_loc=${escape(docloc ?? '').substring(0, 200)}`,
		`trk_agn=${escape(navigator.appName).substring(0, 100)}`,
		`trk_agv=${escape(
			`${navigator.userAgent}.lfcd${screen.colorDepth}.lflng`
		).substring(0, 1000)}`,
		`trk_dom=${escape(document.domain).substring(0, 200)}`,
		`trk_guid=${generateGuid()}`,
		'trk_cookie=NA',
	];

	const preload = new Image();
	preload.src = `${leadForensicsConfig.captureUrl}?${params.join('&')}`;
};

const getAnchorTitle = (anchor, url) =>
	anchor.textContent?.trim() ||
	anchor.getAttribute('aria-label') ||
	anchor.getAttribute('title') ||
	url;

const getTrackableUrl = (anchor) => {
	let url;

	try {
		url = new URL(anchor.href, window.location.href);
	} catch (error) {
		return null;
	}

	if (!['http:', 'https:'].includes(url.protocol)) {
		return null;
	}

	return url.href;
};

const trackNavigationLink = (e) => {
	const selector =
		leadForensicsConfig.navigationSelector ?? '.block-navigation a[href]';
	const anchor = e.target.closest(selector);

	if (!anchor) {
		return;
	}

	const url = getTrackableUrl(anchor);

	if (!url) {
		return;
	}

	trackLoad(url, getAnchorTitle(anchor, url));
};

export default function leadForensics() {
	if (!leadForensicsConfig.enabled) {
		return;
	}

	window.track_load = trackLoad;

	document.addEventListener('click', trackNavigationLink);
}
